import { Cookies } from 'react-cookie';
import { apiClient, apiClientPaymentIntent } from '../services/axios';
import {setUserId} from "../../redux/reducers/api/UserTokenSlice";

const COOKIE_EXPIRY_SECONDS = 60 * 60 * 24 * 365; // 1 year

export const AuthTokenApi = (token: string | null) => {
  const cookies = new Cookies();

  if (token) {
    apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
    apiClientPaymentIntent.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    cookies.remove('token');
    cookies.remove('refresh_token');
    delete apiClient.defaults.headers.common.Authorization;
    delete apiClientPaymentIntent.defaults.headers.common.Authorization;
  }
};

export const setTokensToCookies = (
  access_token: string,
  refresh_token: string,
  user_id?: string
) => {
  const cookies = new Cookies();

  cookies.set('token', access_token, { maxAge: COOKIE_EXPIRY_SECONDS });
  cookies.set('refresh_token', refresh_token, { maxAge: COOKIE_EXPIRY_SECONDS });
  cookies.set('user_id', user_id, { maxAge: COOKIE_EXPIRY_SECONDS });
};
